import { localize } from "@/i18n/translate";
import { motion, useReducedMotion } from "framer-motion";
const NODES = [{
  id: "a",
  x: 92,
  y: 110,
  label: "IDENTITÄT"
}, {
  id: "b",
  x: 392,
  y: 92,
  label: "CLOUD"
}, {
  id: "c",
  x: 420,
  y: 278,
  label: "NETZWERK"
}, {
  id: "d",
  x: 340,
  y: 410,
  label: "DATEN"
}, {
  id: "e",
  x: 120,
  y: 392,
  label: "BETRIEB"
}, {
  id: "f",
  x: 56,
  y: 252,
  label: "ZUGANG"
}];
const pathTo = (n, i) => i % 2 === 0 ? `M240 240 H${n.x} V${n.y}` : `M240 240 V${n.y} H${n.x}`;
const DOTS = Array.from({
  length: 13 * 13
}, (_, i) => ({
  x: i % 13 * 40,
  y: Math.floor(i / 13) * 40
}));
export const NetworkGraphic = ({
  labels,
  ariaLabel
}) => {
  const reduce = useReducedMotion();
  return <svg viewBox="0 0 480 480" className="h-full w-full overflow-visible" role="img" aria-label={localize(ariaLabel)}>
      <g fill="#1B1C1E" opacity="0.18">
        {localize(DOTS.map(d => <circle key={`${d.x}-${d.y}`} cx={d.x} cy={d.y} r="1.1" />))}
      </g>
      <g className="spin-slow" fill="none" stroke="#1B1C1E" strokeOpacity="0.35">
        <circle cx="240" cy="240" r="132" strokeDasharray="2 7" />
      </g>
      <rect x="168" y="168" width="144" height="144" fill="none" stroke="#1B1C1E" strokeOpacity="0.25" />
      {localize(NODES.map((n, i) => <g key={n.id}>
          <motion.path d={pathTo(n, i)} fill="none" stroke="#1B1C1E" strokeOpacity="0.55" strokeWidth="1" initial={reduce ? false : {
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 1.4,
        delay: 0.6 + i * 0.12,
        ease: [0.22, 1, 0.36, 1]
      }} />
          <path d={pathTo(n, i)} fill="none" stroke="#D52B1E" strokeWidth="1.5" className="flow-line" opacity="0.8" />
          {localize(!reduce && <circle r="3" fill="#D52B1E">
              <animateMotion dur={`${4 + i * 0.6}s`} repeatCount="indefinite" path={pathTo(n, i)} keyPoints="1;0" keyTimes="0;1" calcMode="linear" />
            </circle>)}
          <motion.g initial={reduce ? false : {
        opacity: 0,
        scale: 0.6
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 1.3 + i * 0.1
      }} style={{
        transformOrigin: `${n.x}px ${n.y}px`
      }}>
            <rect x={n.x - 7} y={n.y - 7} width="14" height="14" fill="#F6F4EF" stroke="#1B1C1E" strokeWidth="1.25" />
            <rect x={n.x - 2.5} y={n.y - 2.5} width="5" height="5" fill="#1B1C1E" />
            <text x={n.x + (n.x > 240 ? -14 : 14)} y={n.y - 14} textAnchor={n.x > 240 ? "end" : "start"} className="font-mono" fontSize="12" letterSpacing="2" fill="#55575C">
              {localize(labels?.[i] ?? n.label)}
            </text>
          </motion.g>
        </g>))}
      <rect x="216" y="216" width="48" height="48" fill="#D52B1E" className="pulse-ring" opacity="0.5" />
      <rect x="212" y="212" width="56" height="56" fill="#D52B1E" />
      <g fill="#fff">
        <rect x="235" y="225" width="10" height="30" />
        <rect x="225" y="235" width="30" height="10" />
      </g>
    </svg>;
};
